import React, { useState } from 'react';
import {
  CompositeView,
  GridView,
  SimpleView,
  usePromise
} from '@digital/ui';


import { getAllRegraSubstituto, UsuarioSubstitutoModel, getVerificarPerilLogado, VerificarPerfilLogado } from '@app/api/RegraSubstituto';
import AbaRegrasSubstituicao from './RegrasSubstituicao';

const UsuarioSubstituto = () => {

  const [update, setUpdate] = useState(true);

  const onUpdate = () => {
    setUpdate(!update);
  };

  const [usuarioSubstitutoPromise] = usePromise(
    async () => {
      return await getAllRegraSubstituto();
    },
    [update],
    {} as UsuarioSubstitutoModel,
  );

  const [PerfilLogadoPromise] = usePromise(
    async () => {
      return await getVerificarPerilLogado();
    },
    [update],
    {} as VerificarPerfilLogado,
  )

  return (
    <SimpleView>
      <CompositeView>
        <GridView icon="ui-in_progress" noform id="RegrasSubstituicao" title="REGRAS DE SUBSTITUIÇÃO">
          <AbaRegrasSubstituicao DadosRegrasSubstituicao={usuarioSubstitutoPromise} PerfilLogado={PerfilLogadoPromise} updatePage={onUpdate} />
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};

export default UsuarioSubstituto;